import Control from "ol/control/Control";

export class WKTInputControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement("div");
    element.className = "wkt-input ol-unselectable";

    super({
      element: element,
      target: options.target,
    });

    const this_ = this;
    this_.set("validWkt", true);

    const textarea = document.createElement("textarea");
    textarea.placeholder =
      "Enter WKT strings or boundary codes. e.g.:POINT (12.3403085 45.4340351) deu LINESTRING (12.3403085 45.4340351, 12.3385887 45.4335411)";
    textarea.rows = 4;
    element.appendChild(textarea);

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = true;
    checkbox.id = "wkt";
    element.appendChild(checkbox);
    this_.set("wktToggle", checkbox.checked);

    checkbox.addEventListener("change", function () {
      this_.set("wktToggle", checkbox.checked);
    });

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    element.appendChild(label);

    const button = document.createElement("button");
    button.innerHTML = "Map It";
    button.addEventListener(
      "click",
      function () {
        // Set before "wkt" so the WKTLayer's propertychange listener sees the
        // request to zoom to the feature extent. URL restoration never sets
        // this flag, so reloads preserve the URL's center/zoom instead.
        this_.set("zoomToExtent", true);
        this_.set("wkt", textarea.value);
      },
      false,
    );
    label.appendChild(button);

    // Error message element
    const errorMessage = document.createElement("span");
    errorMessage.className = "wkt-error-message";
    errorMessage.style.display = "none";
    label.appendChild(errorMessage);

    // listen to changes
    this.on("propertychange", (e) => {
      // Only sync the textarea when the `wkt` property itself changed. Any
      // other propertychange (zoomToExtent / validWkt / errorMessage) would
      // otherwise clobber in-progress edits with the previously-mapped value.
      if (e.key === "wkt" && this_.get("wkt") !== undefined) {
        textarea.value = this_.get("wkt");
      }
      if (e.key === "wktToggle") {
        checkbox.checked = this_.get("wktToggle") ?? true;
      }
      if (this_.get("validWkt")) {
        textarea.classList.remove("error");
        errorMessage.style.display = "none";
        errorMessage.textContent = "";
      } else {
        textarea.classList.add("error");
        const error = this_.get("errorMessage");
        if (error) {
          errorMessage.textContent = error;
          errorMessage.style.display = "inline";
        }
      }
    });
  }
}
